<script setup>
import DevicesTables from "@/components/Dashboard/Devices/totalDevices/DevicesTable.vue";
</script>

<template>
  <section class="content">
    <div class="container-fluid">
      <div class="row">
        <div class="col-12">
          <div class="card">
            <div class="card-header">
              <h3 class="card-title">FILTERED DEVICES:</h3>
            </div>
            <DevicesTables />
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
